import { createAsyncThunk } from "@reduxjs/toolkit";
import { getUploadLimitsData, postUploadImage } from "../../helpers/backend_helper";
import { setUploadedFiles } from "./reducer";
import { toast } from "react-toastify";

export const getUploadLimits = createAsyncThunk("upload/getUploadLimitsData", async (data, { dispatch, getState }) => {
  try {
    const brandId = getState().MenuData.brandPath;
    const response = await getUploadLimitsData({ brandId: brandId });
    return response.data;
  } catch (error) {
    // console.log(error);
  }
});

export const sendUploadFiles = (files) => async (dispatch, getState) => {
  const {language} = getState().MenuData;
  try {
    const { client, clientPath, brandPath, marketPath, campaignPath } = getState().MenuData;
    let i = 0;
    let uploadedSizes = [];
    do {
      let response = await postUploadImage({ files: files[i], companyId: client._id, clientId: clientPath, campaignId: campaignPath, brandId: brandPath, marketId: marketPath });
      if (response.data[0][0]) {
        uploadedSizes.push(response.data[0]);
      } else {
        throw { code: response.code }
      }
      i++;
    } while (i < files.length);
    dispatch(setUploadedFiles(null));
    // console.log(uploadedSizes);
    if (uploadedSizes.length > 0) {
      return uploadedSizes;
    } else {
      return null;
    }
  } catch (error) {
    toast.error(language[error?.code], {autoClose: 3000});
    return error;
    // console.log(error);
  }
};